import { useQualityMetricsContext } from '../../quality-metrics-context';
import styles from './definition-tab.module.scss';

export function DefinitionTab() {
  const { qualityMetric, lang } = useQualityMetricsContext();
  const { description, numerator, denominator } = qualityMetric;

  return (
    <div className={styles.container}>
      {description && (
        <p className={styles.section}>
          <span className={styles.sectionTitle}>{lang.DEFINITION}:</span>
          <br />
          {description}
        </p>
      )}

      {numerator && (
        <p className={styles.section}>
          <span className={styles.sectionTitle}>{lang.NUMERATOR}:</span>
          <br />
          {numerator}
        </p>
      )}

      {denominator && (
        <p className={styles.section}>
          <span className={styles.sectionTitle}>{lang.DENOMINATOR}:</span>
          <br />
          {denominator}
        </p>
      )}
    </div>
  );
}
